var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDroplet = function SvgDroplet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 2.017a.6.6 0 0 1 .588.483c.466 2.324 1.868 4.572 3.738 6.068 2.082 1.666 3.187 3.703 3.187 5.9A7.516 7.516 0 0 1 12 21.982a7.516 7.516 0 0 1-7.514-7.514c0-2.197 1.105-4.234 3.188-5.9 1.87-1.496 3.273-3.744 3.738-6.068A.6.6 0 0 1 12 2.017m0 2.667a12.03 12.03 0 0 1-3.576 4.821C6.557 11 5.686 12.715 5.686 14.468a6.315 6.315 0 0 0 10.778 4.465 6.32 6.32 0 0 0 1.85-4.465c0-1.752-.871-3.469-2.738-4.963A12.04 12.04 0 0 1 12 4.685"
  })));
};
export default SvgDroplet;